<template>
  <div>
    <div class="search-form">
      <el-form
        inline
        :model="searchData"
        :rules="rules"
        ref="searchForm"
      >
        <el-form-item
          label="操作名称"
          prop="operateName"
        >
          <el-input v-model="searchData.operateName" />
        </el-form-item>
        <el-form-item
          label="操作人ID"
          prop="updateId"
        >
          <el-input v-model="searchData.updateId" />
        </el-form-item>
        <el-form-item
          label="操作时间"
          style="margin-right: 12px;"
          prop="startTime"
        >
          <el-date-picker
            v-model="searchData.startTime"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            :picker-options="$_yh_before(searchData.endTime)"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="至"
          prop="endTime"
        >
          <el-date-picker
            v-model="searchData.endTime"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            :picker-options="$_yh_after(searchData.startTime)"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="操作人姓名"
          prop="opUserName"
        >
          <el-input v-model="searchData.opUserName" />
        </el-form-item>
      </el-form>
    </div>
    <div class="flex-between">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="handleQueryClick"
        >查询</el-button>
        <el-button
          size="small"
          @click="handleResetClick"
        >清空查询条件</el-button>
      </div>
    </div>
    <el-table :data="tableData">
      <template slot="empty">
        {{emptyText}}
      </template>
      <el-table-column
        v-for="col in tableLabelList"
        :key="col.prop"
        :label="col.label"
        :prop="col.prop"
        :formatter="formatter"
      />
    </el-table>
    <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
    />
  </div>
</template>
<script>
import { getPagingData, addNav } from '@/mixins';

export default {
  name: 'SysLog',
  mixins: [getPagingData, addNav],
  data() {
    const lengthCheck = (rule, value, cb) => {
      if (value.length > 50) {
        cb(this.$MSG.M0109);
      } else {
        cb();
      }
    };
    return {
      rules: {
        operateName: [{ validator: lengthCheck }],
        updateId: [{ validator: lengthCheck }, {
          validator: (rule, value, cb) => {
            if (/^\d+$/g.test(value) || !value) {
              cb();
            } else {
              cb(this.$MSG.M0213);
            }
          },
        }],
        opUserName: [{ validator: lengthCheck }],
      },
      tableLabelList: [{
        prop: 'id',
        label: '日志ID',
        width: 200,
      }, {
        prop: 'operateName',
        label: '操作名称',
        width: 200,
      }, {
        prop: 'operateObject',
        label: '操作对象',
        width: 200,
      }, {
        prop: 'ip',
        label: '请求设备IP',
        width: 200,
      }, {
        prop: 'updateTime',
        label: '操作时间',
        width: 200,
      }, {
        prop: 'orgnName',
        label: '所属机构',
        width: 200,
      }, {
        prop: 'opUserName',
        label: '操作人',
        width: 200,
      }, {
        prop: 'updateId',
        label: '操作人ID',
        width: 200,
      }],
      // 初始数据
      searchData: {
        operateName: '',
        startTime: '',
        endTime: '',
        updateId: '',
        opUserName: '',
      },
      // 查询数据
      searchParam: {
        operateName: '',
        startTime: '',
        endTime: '',
        updateId: '',
        opUserName: '',
      },
      tableData: [],
      sumCount: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  watch: {
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData();
      },
    },
  },
  methods: {
    formatter(row, col, cellValue) {
      const needTimeFormatter = ['updateTime'];
      if (needTimeFormatter.includes(col.property)) {
        return this.formatTime(cellValue);
      }
      return cellValue || '-';
    },
    // 查询按钮
    handleQueryClick() {
      console.log('sss');
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.searchParam = { ...this.searchData };
          if (this.currentPage === 1) {
            this.getTableData();
          } else {
            this.currentPage = 1;
          }
        }
      });
    },
    // 重置按钮
    handleResetClick() {
      Object.keys(this.searchData).forEach((key) => {
        this.searchData[key] = '';
        this.searchParam[key] = '';
      });
    },
    // 跳转操作日志详情
    handleDetailClick(row) {
      this.addNav({
        name: '操作日志详情',
        path: '/sysLogDetail',
      });
      sessionStorage.setItem('sysLogDetail', JSON.stringify(row));
    },
    // 获取表格数据
    getTableData() {
      this.getPagingData(this.$API.operateLogQuery);
    },
  },
};
</script>
